import { render, staticRenderFns } from "./FindBestBusinessInTown.vue?vue&type=template&id=48b632d3&scoped=true&"
import script from "./FindBestBusinessInTown.vue?vue&type=script&lang=js&"
export * from "./FindBestBusinessInTown.vue?vue&type=script&lang=js&"
import style0 from "./FindBestBusinessInTown.vue?vue&type=style&index=0&id=48b632d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b632d3",
  null
  
)

export default component.exports